import api from '../../plugins/api';

const startStockReport = (params = {}) => {
  return api.post('/api/crm/cars/stockReport/start', params);
};

export default startStockReport;
